module.exports = __webpack_public_path__ + "static/media/21ECLAC25.19004c88.jpg";